var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { E_IDENTITY_STATUS } from 'src/ui/views/dynamics/CaseGlobalViewPage/sections/CaseInformation/types';
import { ComparisonItem } from 'src/ui/views/dynamics/CaseGlobalViewPage/sections/History/HistoryList/HistoryItems/ComparisonItem/ComparisonItem';
import { E_IDENTITY_VISIBLE_FIELDS } from 'src/redux/cases/types/casesTypes';
import { getGenderLabel } from 'src/shared/helpers/i18nHelpers';
export var IdentityStatusItem = function (props) {
    var i18n = props.i18n, identityStatusUpdate = props.identityStatusUpdate, applicants = props.applicants;
    var author = identityStatusUpdate.author, applicant = identityStatusUpdate.applicant, reason = identityStatusUpdate.reason, status = identityStatusUpdate.status;
    var applicantFiltered = applicants.find(function (appl) {
        return appl.id === applicant.id;
    });
    var applicantFullName = "".concat(applicantFiltered === null || applicantFiltered === void 0 ? void 0 : applicantFiltered.firstName, " ").concat(applicantFiltered === null || applicantFiltered === void 0 ? void 0 : applicantFiltered.lastName);
    var description = getPropsByKeyPath(i18n.modules, 'timeline.identityStatusUpdate.message').replace('$applicant', applicantFullName);
    var statusDescription = getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.infoItems.applicant.identityStatus.".concat(status, ".label"));
    var reasonLabel = getPropsByKeyPath(i18n.keyValueMap, "caseGlobalView.infoItems.applicant.identityStatusReason.".concat(reason, ".label"));
    var reasonDescription = reason ? getPropsByKeyPath(i18n.modules, 'timeline.identityStatusUpdate.reason') : '';
    var authorLabel = (author === null || author === void 0 ? void 0 : author.login) || getPropsByKeyPath(i18n, 'modules.timeline.defaultUser');
    var toStudyLabel = getPropsByKeyPath(i18n.modules, 'timeline.identityStatusUpdate.identityCheckStart');
    var fields = [
        E_IDENTITY_VISIBLE_FIELDS.HONORIFIC_PREFIX,
        E_IDENTITY_VISIBLE_FIELDS.GENDER,
        E_IDENTITY_VISIBLE_FIELDS.GIVEN_NAME,
        E_IDENTITY_VISIBLE_FIELDS.GIVEN_NAME2,
        E_IDENTITY_VISIBLE_FIELDS.GIVEN_NAME3,
        E_IDENTITY_VISIBLE_FIELDS.FAMILY_NAME,
        E_IDENTITY_VISIBLE_FIELDS.BIRTH_NAME,
        E_IDENTITY_VISIBLE_FIELDS.BIRTH_DATE,
        E_IDENTITY_VISIBLE_FIELDS.BIRTH_PLACE,
        E_IDENTITY_VISIBLE_FIELDS.DOCUMENT_NUMBER,
        E_IDENTITY_VISIBLE_FIELDS.MRZ_LINES,
        E_IDENTITY_VISIBLE_FIELDS.EXPIRATION_DATE,
    ];
    var content = (_jsxs("p", { children: [_jsx("b", { children: authorLabel }), " ", description, " ", _jsx("b", { children: statusDescription }), " ", reasonDescription, " ", _jsx("b", { children: reasonLabel })] }));
    if (status === E_IDENTITY_STATUS.VALID) {
        var inputIdentityEnhanced = __assign(__assign({}, identityStatusUpdate.inputIdentity), { gender: identityStatusUpdate.inputIdentity.gender
                ? getGenderLabel(i18n, identityStatusUpdate.inputIdentity.gender)
                : null });
        var reviewedIdentityEnhanced = __assign(__assign({}, identityStatusUpdate.reviewedIdentity), { gender: identityStatusUpdate.reviewedIdentity.gender
                ? getGenderLabel(i18n, identityStatusUpdate.reviewedIdentity.gender)
                : null });
        return (_jsx(ComparisonItem, { i18n: i18n, fields: fields, description: content, previousIdentity: inputIdentityEnhanced, nextIdentity: reviewedIdentityEnhanced }));
    }
    if (status === E_IDENTITY_STATUS.TO_STUDY) {
        return (_jsx("div", { children: _jsxs("p", { children: [_jsx("b", { children: applicantFullName }), " ", toStudyLabel] }) }));
    }
    return _jsx("div", { children: content });
};
